import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromContainers from './containers';
import * as fromComponents from './components';
import { CommentsRoutingModule } from './comments-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [...fromContainers.containers, ...fromComponents.components],
  imports: [CommonModule, CommentsRoutingModule, SharedModule],
  exports: [...fromContainers.containers, ...fromComponents.components],
  entryComponents: [...fromContainers.entryContainers]
})
export class CommentsModule {}
